import { queryClient } from '../config/client';

export const invalidateFavoriteSwings = () => {
    queryClient.invalidateQueries({
        predicate: (query) => {
            const key = query.queryKey;
            return key[0] === 'swings' && key[1] === 'favorite';
        },
    });
};
